import { autoinject } from "aurelia-dependency-injection";
import { EventAggregator } from "aurelia-event-aggregator";
import { bindable } from "aurelia-templating";
import { Messages } from "../../constants/event-messages.constants";

//Load styles
require("./comp-mobile-filter.scss");

@autoinject()
export class CompMobileFilter {

    // Holds the html present within the <slot> tag. This html is then sent to the parent element
    // (supposedly comp-mobile-filters) when the filter is selected
    private _slotContentElement;

    // The content displayed when (if the filter is toggable) the filter is clicked
    public slotContent: HTMLElement;

    // The label text of the filter
    @bindable
    public label: string = "";

    // Is the filter selected or not
    @bindable
    public isSelected: boolean;

    // Determines whether the filter displays sub-filters when clicked
    @bindable
    public isToggable: boolean;

    // The filter count (number displayed next to filter label)
    @bindable
    public count: number;

    // Description text under the label text and count
    @bindable
    public description: string;

    // Display the 'chevron right' icon
    @bindable
    public showChevronRight: boolean;

    @bindable
    public lockedFeature: boolean = false;

    constructor(private eventAggregator: EventAggregator) { }

    attached() {
        // Initially store the slot content
        this._slotContentElement = this.slotContent.getElementsByClassName('slot-content-wrapper')[0];
        // Remove the slot content wrapper, as it introduces issues because elements within it are still
        // rendered in DOM (as show.bind is used)
        this.slotContent.removeChild(this.slotContent.getElementsByClassName('slot-content-wrapper')[0]);
    }

    detached() {
        // Place previous slot html content back into slot element (if this is omitted, this mobile-filter component
        // would find an empty slot element when its displayed (attached to DOM) again)
        this.slotContent.appendChild(this._slotContentElement);
    }

    /**
     * Filter clicked event handler
     * @param $event Event
     */
    filterClickedHandler($event: Event) {
        $event.stopPropagation();

        if(this.lockedFeature){
            this.eventAggregator.publish(Messages.unlockFeature);
            return;
        }
        
        const events: CustomEvent[] = [];

        // Register 'click' event
        events.push(new CustomEvent('filter-clicked', { bubbles: true }))

        // If the mobile filter is toggable, register filter 'selected' event (so that the <slot> content
        // is shown in the <comp-mobile-filters>
        if (this.isToggable) {
            events.push(new CustomEvent('filter-selected', {
                bubbles: true,
                detail: this._slotContentElement
            }));
        }

        // Dispatch events
        events.forEach((event: CustomEvent) => {
            $event.target.dispatchEvent(event);
        });
    }
}
